import { createSelector } from '@reduxjs/toolkit';

const selectSelf = (state) => state;

export const UACActiveUser = createSelector(selectSelf, (state) => {
  const selectedAccountId = state.UACReducers?.MACR?.CurrentAccountID;
  return state.UACReducers?.MALR?.ManagedAccounts?.find(({ IsActive, ID }) => (selectedAccountId ? ID === selectedAccountId : IsActive)) ?? null;
});
